import { useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import { useActions, useAppSelector } from 'store/hooks'

import { orderFormSpace } from '../namespaces/orderFormSpace'
import { useGetOrderProdTypeByFormQuery } from '../redux/orders.api'

function findProductById(
  list: {
    id: number
    name: string
    children?: { list: { id: number; name: string }[] }
  }[],
  id: number,
): { id: number; name: string } | null {
  for (const item of list) {
    if (item.id === id) return { id: item.id, name: item.name }
    if (item.children?.list) {
      const child = item.children.list.find(c => c.id === id)
      if (child) return { id: child.id, name: child.name }
    }
  }
  return null
}

export function usePreselectProduct(
  orderType: orderFormSpace.FormType,
  productId: number | null,
): boolean {
  const { toggleProductOrder, setActiveStepOrder, clearProductsOrder } =
    useActions()
  const [, setSearchParams] = useSearchParams()
  const currentProducts = useAppSelector(
    state => state.orderForm.forms[orderType].products,
  )

  const [isReady, setIsReady] = useState(!productId)

  const { data: productTypeData } = useGetOrderProdTypeByFormQuery(orderType, {
    skip: !productId,
  })

  useEffect(() => {
    if (!productId || !productTypeData) return

    const found = findProductById(productTypeData.list, productId)

    if (found) {
      const isExactMatch =
        currentProducts.length === 1 && currentProducts[0].id === productId

      if (!isExactMatch) {
        clearProductsOrder()
        toggleProductOrder(found)
        setActiveStepOrder(1)
      }
    }

    // Убираем productId из URL, чтобы при обновлении страницы
    // или добавлении новых товаров данные заказа не сбрасывались
    setSearchParams(
      prev => {
        prev.delete('productId')
        return prev
      },
      { replace: true },
    )

    setIsReady(true)
  }, [productTypeData])

  return isReady
}
